import { PerformanceProfileData } from './performance-profile-data';

/**
 * Performance profile measurement record.
 */
export interface PerformanceProfileRecord extends PerformanceProfileData {
    /**
     * Primary Key on the database.
     */
    primaryKey?: number;

    /**
     * Browser session ID.
     */
    sessionId: string;

    /**
     * Timestamp when it's recorded.
     */
    timestamp: number;

    /**
     * The module name of this record.
     */
    moduleName: string;
}
